<template>
  <auth-container
    :title="title"
    :description="description"
    :titleColor="titleColor"
    :images="config.images.carousel"
    :mobileImages="config.images.carouselMobile"
  >
    <div class="forgot-password">
      <v-card>
        <v-card-text>
          <v-form class="pt-3" ref="form" @submit.prevent="submit">
            <text-field
              label="CPF ou CNPJ"
              v-model="username"
              :rules="rule.required"
              :error-messages="error.username"
              :mask="['###.###.###-##', '##.###.###/####-##']"
              required
            ></text-field>
            <v-layout row wrap justify-space-between>
              <v-flex d-flex xs6 sm5>
                <v-btn type="submit" color="green" class="btn-md">
                  <v-progress-circular
                    color="white"
                    indeterminate
                    v-if="loadingApp"
                  ></v-progress-circular>
                  <div class="button__text" v-else>Recuperar senha</div>
                </v-btn>
              </v-flex>
              <v-spacer v-if="!mobile" />
              <v-flex d-flex xs6 sm5>
                <v-btn @click="checkClient" color="orange" class="btn-md">
                  <v-progress-circular
                    color="white"
                    indeterminate
                    v-if="loadingApp"
                  ></v-progress-circular>
                  <div class="button__text" v-else>
                    Já tenho senha temporária
                  </div>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </auth-container>
</template>

<script>
import AuthContainer from '@/components/auth/Container';
import TextField from '@/components/fields/TextField';
import { CONFIG, ROLES } from '../../utils/constants';
import { validateDocument } from '../../utils/documentValidation';

export default {
  name: 'access',
  components: {
    AuthContainer,
    TextField,
  },
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
  },
  data() {
    return {
      title: 'Esqueci minha senha',
      description:
        'Informe seu CPF ou CNPJ e receba a senha de acesso no seu e-mail.',
      titleColor: '#dd2e36',
      error: {},
      username: '',
      userRole: ROLES.CLIENT_ROLE,
    };
  },
  created() {
    this.userRole = this.$router.currentRoute.meta.userRole;
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        if (!validateDocument(this.username)) {
          this.error = this.enums.responses.invalidUsername;
          return;
        }
        const url = `${process.env.AUTH_API_URL}/recoverPassword`;
        const username = this.stripNonNumeric(this.username);
        const body = {
          username,
          userRole: this.userRole,
        };
        try {
          const result = await this.requestService(url, 'POST', 
          {
            data: body,
            localErrorHandling: true
          });
          if (result) {
            this.goToResetPassword(username, result.email, false);
          }
        } catch (err) {
          if (err && err.data && err.data.message) {
            if (
              err.data.message === 'This user has not been verified' ||
              err.data.message == 'This user does not exist'
            ) {
              this.$router.push({
                name: 'login',
                params: { sendToSignUp: true, username },
              });
            }
          }

          this.error = this.handleAuthError(err);
        }
      }
    },
    async checkClient() {
      if (this.$refs.form.validate()) {
        if (!validateDocument(this.username)) {
          this.error = this.enums.responses.invalidUsername;
          return;
        }
        const url = `${process.env.AUTH_API_URL}/user/checkClient`;
        const username = this.stripNonNumeric(this.username);
        const params = {
          username,
          userRole: ROLES.CLIENT_ROLE,
        };
        try {
          const result = await this.requestService(
            url,
            'GET',
            {
              params,
              localErrorHandling: true,
              auth: false
            }
          );
          if (result && result.user && result.verified) {
            this.goToResetPassword(username, result.email);
          } else if (!result.user || !result.verified) {
            this.$router.push({
              name: 'login',
              params: { sendToSignUp: true, username },
            });
          }
        } catch (err) {
          if (err && err.data && err.data.message) {
            if (
              [
                'This user does not exist',
                'This user has not been verified',
              ].includes(err.data.message)
            ) {
              this.$router.push({
                name: 'login',
                params: { sendToSignUp: true, username },
              });
            }
          }

          this.error = this.handleAuthError(err);
        }
      }
    },
    goToResetPassword(username, email) {
      this.$router.push({
        name:
          this.userRole === ROLES.SYNDIC_ROLE
            ? 'syndicResetPassword'
            : 'resetPassword',
        query: {
          username,
          email,
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint';

.forgot-password {
  &__go-back {
    color: var(--label-color) !important;
    font-weight: 400;
  }

  .v-btn {
    >>> .button__text {
      white-space: normal;
      word-break: break-word;
      width: 95%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/ForgotPassword.vue